import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProviderQuickAccess from './components/ProviderQuickAccess';
import WinnerTicker from './components/WinnerTicker';
import ProviderFilter from './components/ProviderFilter';
import GameGrid from './components/GameGrid';
import Event from './components/Event';
import VIPSection from './components/VIPSection';
import SecuritySection from './components/SecuritySection';
import Footer from './components/Footer';
import NotificationModal from "./components/NotificationModal";

export default function Home() {
  const [selectedProvider, setSelectedProvider] = useState('ALL');
  const [isOpenNotificationDialog, setIsOpenNotificationDialog] = useState(false);
  const onOpenNotiDlg = () => setIsOpenNotificationDialog(true);
  const onCloseNotiDlg = () => setIsOpenNotificationDialog(false);

  return (
    <div className="min-h-screen relative">
      {/* Fixed Background */}
      <div
        className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Luxurious%20casino%20gaming%20atmosphere%20with%20deep%20purple%20and%20blue%20gradient%20background%20featuring%20subtle%20golden%20light%20particles%20and%20elegant%20bokeh%20effects%20creating%20premium%20entertainment%20ambiance%20with%20soft%20glowing%20orbs%20and%20mystical%20lighting%20in%20dark%20sophisticated%20color%20scheme%20perfect%20for%20high%20end%20gaming%20platform%20with%20cosmic%20stars%20and%20dreamy%20atmosphere&width=1920&height=1080&seq=casino-bg-fixed-001&orientation=landscape)',
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Scrollable Content */}
      <div className="relative z-10">
        <Header onOpenNotiDlg={onOpenNotiDlg} />
        <Hero />
        <ProviderQuickAccess />
        <WinnerTicker />
        {/* <ProviderFilter
          selectedProvider={selectedProvider}
          onProviderChange={setSelectedProvider}
        /> */}
        <GameGrid selectedProvider={selectedProvider} />
        {/* <Event />
        <VIPSection /> */}
        <SecuritySection />
        <Footer />
        <NotificationModal isOpen={isOpenNotificationDialog} onClose={onCloseNotiDlg} />
      </div>
    </div>
  );
}
